import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Banner from "../components/career/Banner";
import Footer from "../layouts/Footer";
import OurArticle from "../components/Home/OurArticle";
import JoinTeam from "../components/career/JoinTeam";
import JoinOurTeam from "../components/Home/JoinOurTeam";
import WhyChoose from "../components/career/WhyChoose";
import UnlockPotential from "../components/career/UnlockPotential";
import WorkCulture from "../components/career/WorkCulture";
import OpenPosition from "../components/career/OpenPosition";
import { motion } from "motion/react";
import { Helmet } from "react-helmet";

const Career = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="volto-homepage career">
        <Header  mode="light"/>
        <Banner />
        <JoinTeam />
        <WhyChoose />
        <UnlockPotential />
        <WorkCulture />
        <OpenPosition />
        <OurArticle />
        <JoinOurTeam  image={"/images/join-our-team.webp"}/>
        
        <Footer />
      </div>
    </motion.div>
  );
};

export default Career;
